<template>
  <div>
    <Upselling
      @cta-click="onClick"
      data-testid="versions-modal-upselling"
      class="p-6 max-w-[460px] border shadow-lg rounded-10 border-slate-300 dark:border-zinc-700"
      :header="header"
      :message="message"
      :cta="cta"
    />
  </div>
</template>
<script setup lang="ts">
import Upselling from '@/components/Upselling.vue';
import { useTrack, TrackEvents } from '@/composables/useTrack';

const { trackItemOwner } = useTrack();

const props = defineProps<{
  header?: string;
  message: string;
  cta?: string;
  isFree?: boolean;
}>();

const onClick = (e: MouseEvent) => {
  e.stopPropagation();
  e.preventDefault();

  trackItemOwner(!props.isFree ? TrackEvents.CONTACT_US_CLICKED : TrackEvents.UPGRADE_CLICK).then(() => {
    window.location.assign('/account/plans');
  });
};
</script>
